import axios from 'axios';
import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { checkPassword, valdiatePage, validateEmail } from '../../global';
import { getPages, getSubAccountLocations, getUsers, getUserSubAccounts, saveUser, updateUser, validateUser, resetPassword, getSubAaccounts } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';
import UserModal from '../../components/userModal';
import Userupdate from './userupdate';
import Useradd from './useradd';
import Pagination from '../../components/paginations';

const User = () => {
    const dispatch = useDispatch();
    const { userInfo } = useSelector(state => state.appData);
    const history = useHistory();

    const d = {
        id: 0,
        name: '',
        password: '12345',
        // retypePassword: '',
        userId: '',
        email: '',
        cnic: '',
        isDuplicateOrderAllowed: false,
        isZeroCodAllowed: false,
        parentId: userInfo?.id || 0,
        createdBy: userInfo?.id || 0,
        locations: [],
        subAccounts: [],
        pages: [],
        addressLabelType: 1,
        shipperInfoType: 1,
        isActive: false,
        selectAll: false
    };

    const currentSA = {
        id: 0,
        name: ''
    };

    const [data, setData] = useState(d);
    const [locations, setLocations] = useState([]);
    const [pages, setPages] = useState([]);
    const [grid, setGrid] = useState([]);
    const [subPages, setSubPages] = useState([]);
    const [viewType, setViewType] = useState('list');
    const [subAccWithLoc, setSubAccWithLoc] = useState([]);
    const [subaccounts, setSubaccounts] = useState([]);

    const [showModal, setShowModal] = useState(false)
    const [currentSubAccount, setCurrentSubAccount] = useState(currentSA);
    const [modalTypeEdit, setModalTypeEdit] = useState(false);
    const [userIdAvailed, setUserIdAvailed] = useState("");

    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    
    const searchObjInit = {
        name: '',
        userId: ''
    };

    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });

    const gridKeys = [
        {key: 'id', name: 'Id', searchBox: false, visible: true},
        {key: 'name', name: 'Name', searchBox: true, visible: true},
        {key: 'userId', name: 'UserId', searchBox: true, visible: true},
        {key: 'email', name: 'Email', searchBox: false, visible: true},
        {key: 'cnic', name: 'CNIC', searchBox: false, visible: true},
        {key: '', name: 'Active', searchBox: false, visible: true},
        {key: '', name: 'Reset Password', searchBox: false, visible: true},
        {key: '', name: 'Edit', searchBox: false, visible: true}
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });


    useEffect(async () => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        if (valdiatePage('/user')) {
            dispatch(setLoading({ data: true }));
            const rs = await getSubAaccounts(userInfo.id, true);
            dispatch(setLoading({ data: false }));

            if (rs.ok) {
                setSubaccounts(rs.data);
            }
            getPages(userInfo.id, source).then(rs => {
                setPages(rs.menus)
                setSubPages(rs.menus.find(e => e.menu === "Home").subMenus)
            }).catch(() => alert('Something Went Wrong'))
        } else {
            history.push('/login');
        }
        return () => {
            source.cancel('Operation canceled by the user.');
        }
    }, []);

    useEffect(() => {
        if (viewType === 'list') {
            (async function () {
                //dispatch(setLoading({ data: true }));
                const rs = await getUsers(userInfo.id);
                //dispatch(setLoading({ data: false }));
                if (rs.ok == 0) {
                    setGrid(rs.data);
                    setOriginalGrid(rs.data);
                }
            }())
        }
    }, [viewType])

    useEffect(() => {
         if(data.selectAll) {
            const allSubMenuValues = pages.flatMap(menu => 
                menu.subMenus.map(sub => Number(sub.value))
            );
            updateData('pages', allSubMenuValues);
        } else {
            updateData('pages', []);
        }
    }, [data.selectAll])

    const updateData = (key, val) => {
        setData({ ...data, [key]: val });
    }

    const onSave = async () => {
        // if (!data.name || data.name.trim() == '') {
        //     alert('Enter Name');
        //     return;
        // }

        // if (!data.password || data.password.trim() == '') {
        //     alert('Enter Password');
        //     return;
        // }

        // if (!checkPassword(data.password)) {
        //     alert('Password must be atlest 8 character long 1 upper & 1 lower case, 1 special and 1 numeric!');
        //     return;
        // }

        // if (!data.retypePassword || data.retypePassword.trim() == '') {
        //     alert('Enter Retype Password');
        //     return;
        // }

        // if (data.password !== data.retypePassword) {
        //     alert('Password and Retype password not matched.');
        //     return;
        // }

        if (!data.cnic || data.cnic.trim() == '') {
            alert('Enter CNIC');
            return;
        }

        if (!data.userId || data.userId.trim() == '') {
            alert('Enter User Id');
            return;
        }

        if (!data.email || data.email.trim() == '') {
            alert('Enter Email');
            return;
        }

        if (data.email && data.email.trim() != '' && validateEmail(data.email)) {
            alert('Email is invalid');
            return false;
        }
        
        if (data.cnic.length != 13) {
            alert('Enter Valid CNIC');
            return;
        }

        if (data.subAccounts.length <= 0) {
            alert('Select at leact one Sub Account.');
            return;
        }

        if (data.pages.length <= 0) {
            alert('Select Pages');
            return;
        }

        const payload = {
            ...data, subAccount: subAccWithLoc.map(e => ({ locationId: e.locations, subAccountId: e.subAccount.id }))
        }
        delete payload.locations;
        delete payload.subAccounts;
        //delete payload.retypePassword;


        dispatch(setLoading({ data: true }));
        const rs = await saveUser(payload);
        dispatch(setLoading({ data: false }));
        alert(rs.msg);
        if (rs.sts == 0) {
            setData(d);
            setViewType('list')
        }
    }

    const userIdAvailable = async (userId) => {
        if (userId !== "") {
            dispatch(setLoading({ data: true }));
            const rs = await validateUser(userId);
            dispatch(setLoading({ data: false }));
            if (rs.ok) {
                setUserIdAvailed("true")
            } else {
                setUserIdAvailed("false")
            }
        }
    }

    const onAdd = () => {
        setSubAccWithLoc([])
        setUserIdAvailed("")
        setViewType('add')
        setData(d)
        setSubPages(pages.length > 0 ? pages.find(e => e.menu === "Home").subMenus : [])
    }

    const onEdit = async (x) => {
        dispatch(setLoading({ data: true }));
        const rs = await getUserSubAccounts(x.id);
        dispatch(setLoading({ data: false }));
        if (rs.locations.length > 0) {
            setSubAccWithLoc(rs.locations.map(e => ({
                subAccount: { name: e.name, id: e.subAccountId },
                locations: e.subAccountLocation.map(e => e.locationId)
            })));
            updateData('subAccounts', rs.locations.map(e => e.subAccountId));
        } else {
            setSubAccWithLoc([])
            updateData('subAccounts', []);
        }
        setSubPages(pages.find(e => e.menu === "Home").subMenus)
        setData(prev => { return { ...prev, id: x.id, name: x.name, userId: x.userId, email: x.email, cnic: x.cnic, isActive: x.isActive, pages: x.pages.map(e => e.submenuId), 
            addressLabelType: x.addressLabelType, isDuplicateOrderAllowed: x.isDuplicateOrderAllowed, isZeroCodAllowed: x.isZeroCodAllowed } })
        setViewType('edit')
    }

    const resetPasswordlocal = async (x) => {
        if (window.confirm('Are you sure?')) {
            dispatch(setLoading({ data: true }));
            setViewType("")
            const rs = await resetPassword(x.userId);
            dispatch(setLoading({ data: false }));
            if (rs.ok) {
                setViewType("list")
                alert("Password is successfully reset. \n Your password is 12345.")
            } else {
                setViewType("list")
                alert("Something went wrong.")
            }
        }
    }

    const onUpdate = async () => {
        // if (!data.name || data.name.trim() === '') {
        //     alert('Enter Name');
        //     return;
        // }

        if (!data.email || data.email.trim() == '') {
            alert('Enter Email');
            return;
        }

        if (data.email && data.email.trim() !== '' && validateEmail(data.email)) {
            alert('Email is invalid');
            return false;
        }
        if (!data.cnic || data.cnic.trim() === '') {
            alert('Enter CNIC');
            return;
        }
        if (data.cnic.length != 13) {
            alert('Enter Valid CNIC');
            return;
        }
        if (data.pages.length <= 0) {
            alert('Select Pages');
            return;
        }
        if (data.subAccounts.length <= 0) {
            alert('Select at least one Sub Account');
            return;
        }
        dispatch(setLoading({ data: true }));
        const rs = await updateUser(data.id, { name: data.name, userId: data.userId, email: data.email, isActive: data.isActive, cnic: data.cnic, pages: data.pages, subAccount: subAccWithLoc.map(e => ({ locationId: e.locations, subAccountId: e.subAccount.id })),
        addressLabelType: data.addressLabelType, isDuplicateOrderAllowed: data.isDuplicateOrderAllowed, isZeroCodAllowed: data.isZeroCodAllowed });
        dispatch(setLoading({ data: false }));
        alert(rs.msg);
        if (rs.ok == 0) {
            setData(d);
            setViewType('list')
        }
    }



    const getSubAccountsLocations = async (id, name) => {
        dispatch(setLoading({ data: true }));
        const locs = await getSubAccountLocations(userInfo.id, id);
        dispatch(setLoading({ data: false }));
        if (locs.length > 0) {
            setShowModal(true)
            setLocations(locs);
            setCurrentSubAccount({ id: Number(id), name: name })
            updateData('locations', []);
        } else {
            alert(`Location not found against sub account ${name}`)
            setLocations([]);
            setCurrentSubAccount(currentSA)
        }
    }

    const reset = () => {
        updateData('locations', []);
    }

    const onSecondClick = () => {
        if (modalTypeEdit) {
            if (data.locations.length > 0) {
                setSubAccWithLoc(subAccWithLoc.map((item) => {
                    return item.subAccount.id == Number(currentSubAccount.id) ? {
                        subAccount: currentSubAccount,
                        locations: data.locations
                    } : item
                }))
                setShowModal(false)
                setModalTypeEdit(false)
            } else {
                alert('Please Select at least One location')
            }
        } else {
            if (data.locations.length > 0) {
                const updatedPages = [...data.subAccounts, Number(currentSubAccount.id)]
                updateData('subAccounts', updatedPages);
                setSubAccWithLoc(prev => [...prev, {
                    subAccount: currentSubAccount,
                    locations: data.locations
                }])
                setShowModal(false)
                setModalTypeEdit(false)
            } else {
                alert('Please Select at least One location')
            }
        }
    }

    const removeSubAccount = (id) => {
        if (window.confirm('Are you sure?') == true) {
            setSubAccWithLoc(subAccWithLoc.filter((item) => { return Number(id) !== item.subAccount.id }))
            let updatedPages = [];
            updatedPages = data.subAccounts.filter((item) => { return Number(id) !== item })
            updateData('subAccounts', updatedPages);
        }
    }

    const editSubAccountLocation = async (id, name) => {
        dispatch(setLoading({ data: true }));
        const locs = await getSubAccountLocations(userInfo.id, id);
        dispatch(setLoading({ data: false }));
        if (locs.length > 0) {
            setLocations(locs);
            setCurrentSubAccount({ id: Number(id), name })
            setModalTypeEdit(true)
            const findSALocation = subAccWithLoc.find((item) => { return Number(id) === item.subAccount.id })
            updateData('locations', findSALocation.locations);
            setShowModal(true)
        }
    }

    const selectAllPages = (e) => {
        updateData('selectAll', e.target.checked)
        if(e.target.checked) {
            const allSubMenuValues = pages.flatMap(menu => 
                menu.subMenus.map(sub => Number(sub.value))
            );
            updateData('pages', allSubMenuValues);
        } else {
            updateData('pages', []);
        }
    }
   
    return userInfo && <section className="section"> 
        {showModal && <UserModal onSecondClick={onSecondClick} response={locations} setShowModal={setShowModal} reset={reset} data={data} updateData={updateData} subAccount={currentSubAccount} />}
        {
            viewType === 'list' ?
                <>
                    <div className="section-header">
                        <h1>Users</h1>
                    </div>
                    <div className="card" style={{ padding: 10 }}>
                        <div style={{ textAlign: 'right' }}><button type='button' className='btn btn-sm btn-primary' onClick={onAdd}>Add User</button></div>
                        <div className='table-responsive'>
                            {
                                <>

                                    <Pagination
                                        setGrid={setGrid}
                                        searchObjInit={searchObjInit}
                                        searchObject={searchObject}
                                        originalGrid={originalGrid}
                                        setPage={setPage}
                                        setPageLimit={setPageLimit}
                                        requestSort={requestSort}
                                        sortConfig={sortConfig}
                                        updateSearchData={updateSearchData}
                                        sortedArray={sortedArray}
                                        data={data}
                                        dataCount={grid.length}
                                        pageLimit={pageLimit}  
                                        gridKeys={gridKeys}
                                        page={page}
                                        grid={
                                            sortedArray && sortedArray.length > 0  &&
                                                sortedArray.map((x, index) =>
                                                        <tr key={index}>
                                                            <td>{(index + 1)+(page*pageLimit)}</td>
                                                            <td>{x.id}</td>
                                                            <td>{x.name}</td>
                                                            <td>{x.userId}</td>
                                                            <td>{x.email}</td>
                                                            <td>{x.cnic}</td>

                                                            <td><div key={index}>
                                                                <label className="small-switch">
                                                                    <input type="checkbox" checked={x.isActive} />
                                                                    <span className="small-slider round"></span>
                                                                </label>
                                                            </div></td>
                                                            <td>
                                                                {
                                                                    x.isPasswordUpdated ? <div><button type='button' className='btn btn-sm btn-primary' onClick={() => resetPasswordlocal(x)}>Reset Password</button></div> : <>Already reset</>
                                                                }

                                                            </td>

                                                            <td>
                                                                <div><button type='button' className='btn btn-sm btn-primary' onClick={() => onEdit(x)}>Edit</button></div>
                                                            </td>
                                                        </tr>)
                                        }
                                    />

                                    {/* <table className='table table-bordered'>
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Name</th>
                                                <th>User Id</th>
                                                <th>Email</th>
                                                <th>CNIC</th>
                                                <th>Active</th>
                                                <th>Reset Password</th>
                                                <th><b>Edit</b></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                grid && grid.length > 0 ?
                                                    grid.map((x, index) =>
                                                        <tr key={index}>
                                                            <td>{x.id}</td>
                                                            <td>{x.info.name}</td>
                                                            <td>{x.info.userId}</td>
                                                            <td>{x.info.email}</td>
                                                            <td>{x.info.cnic}</td>

                                                            <td><div key={index}>
                                                                <label className="small-switch">
                                                                    <input type="checkbox" checked={x.info.isActive} />
                                                                    <span className="small-slider round"></span>
                                                                </label>
                                                            </div></td>
                                                            <td>
                                                                {
                                                                    x.info.isPasswordUpdated ? <div><button type='button' className='btn btn-sm btn-primary' onClick={() => resetPasswordlocal(x)}>Reset Password</button></div> : <>Already reset</>
                                                                }

                                                            </td>

                                                            <td>
                                                                <div><button type='button' className='btn btn-sm btn-primary' onClick={() => onEdit(x)}>Edit</button></div>
                                                            </td>
                                                        </tr>)
                                                    : <tr><td>Users not available</td></tr>
                                            } 
                                        </tbody>
                                    </table>*/}
                                </>
                            }
                        </div>
                    </div>
                </>
                : viewType === 'edit' ?
                    <Userupdate
                        data={data}
                        updateData={updateData}
                        locations={locations}
                        subaccounts={subaccounts}
                        pages={pages}
                        setSubPages={setSubPages}
                        onUpdate={onUpdate}
                        setViewType={setViewType}
                        subPages={subPages}
                        getSubAccountsLocations={getSubAccountsLocations}
                        editSubAccountLocation={editSubAccountLocation}
                        removeSubAccount={removeSubAccount}
                        selectAllPages={selectAllPages}
                    />
                    : viewType === 'add' ?
                        <Useradd
                            data={data}
                            updateData={updateData}
                            locations={locations}
                            subaccounts={subaccounts}
                            pages={pages}
                            setSubPages={setSubPages}
                            getSubAccountsLocations={getSubAccountsLocations}
                            editSubAccountLocation={editSubAccountLocation}
                            removeSubAccount={removeSubAccount}
                            onSave={onSave}
                            setViewType={setViewType}
                            subPages={subPages}
                            userIdAvailed={userIdAvailed}
                            userIdAvailable={userIdAvailable}
                            selectAllPages={selectAllPages}
                        /> : <div className="section-header">
                            <h1>Loaiding Users</h1>
                        </div>
        }
    </section>
}

export default User;
